// The bell's inbox (NotificationService /v1/message-center/me/*, PlunkDocs specs/CONTENT_HUB_REVIEW_DESK_2026-10-21.md §7).
// One unread count shared by the toolbar badge, the panel and the Notifications page: polled every 60 s while the tab is
// visible and again when it comes back into view. Everything is the signed-in person's own inbox (the server takes the
// recipient from the token).
import ServiceFactory from "../service";
const APP = "commerce";
const svc = api => {
  const S = ServiceFactory.getType(api, "product");
  return new S();
};
let unread = 0;
let timer = null;
const listeners = new Set();
const emit = () => listeners.forEach(fn => {
  try {
    fn(unread);
  } catch (e) {/* listener gone */}
});
export async function refreshUnread() {
  try {
    const r = await svc(`/message-center/me/unread-count?app=${APP}`).getAsync();
    const n = Number(r && r.unread) || 0;
    if (n !== unread) {
      unread = n;
      emit();
    }
  } catch (e) {/* bell stays as it was */}
  return unread;
}

/** Subscribe to the unread count; starts the poller on the first subscriber. Returns an unsubscribe function. */
export function onUnread(fn) {
  listeners.add(fn);
  fn(unread);
  if (!timer) {
    refreshUnread();
    timer = setInterval(() => {
      if (typeof document === "undefined" || !document.hidden) refreshUnread();
    }, 60000);
    if (typeof document !== "undefined") document.addEventListener("visibilitychange", () => {
      if (!document.hidden) refreshUnread();
    });
  }
  return () => listeners.delete(fn);
}
export async function listInbox({
  filter = "all",
  app = APP,
  before = null,
  limit = 30
} = {}) {
  const q = [`filter=${encodeURIComponent(filter)}`, app ? `app=${encodeURIComponent(app)}` : "", before ? `before=${encodeURIComponent(before)}` : "", `limit=${limit}`].filter(Boolean).join("&");
  const r = await svc(`/message-center/me/messages?${q}`).getAsync();
  if (r && typeof r.unread === "number" && r.unread !== unread && (!app || app === APP)) {
    unread = r.unread;
    emit();
  }
  return {
    items: r && r.items || [],
    unread: r && r.unread || 0
  };
}
export async function markRead(id) {
  await svc(`/message-center/me/messages/${encodeURIComponent(id)}/read`).putAsync({});
  if (unread > 0) {
    unread -= 1;
    emit();
  }
}
export async function markAllRead() {
  await svc(`/message-center/me/read-all?app=${APP}`).putAsync({});
  unread = 0;
  emit();
}
export async function getPreferences() {
  return svc("/message-center/me/preferences").getAsync();
}
export async function savePreferences(preferences) {
  return svc("/message-center/me/preferences").putAsync(preferences);
}

// ---- presentation shared by the panel and the page
export const EVENT_ICON = {
  "content.assigned": ["assignment_ind", "info"],
  "content.mentioned": ["alternate_email", ""],
  "content.comment": ["chat_bubble_outline", ""],
  "content.review_result": ["fact_check", "ok"],
  "studio.job_finished": ["auto_awesome_motion", ""],
  "studio.job_handoff": ["forward", "info"],
  "board.activity": ["forum", ""],
  "quote.activity": ["request_quote", "warn"],
  "flight.launched": ["rocket_launch", "ok"],
  "connection.needs_attention": ["link_off", "bad"],
  "wallet.campaigns_paused": ["account_balance_wallet", "warn"]
};
export const iconFor = item => EVENT_ICON[item.eventType] || ["notifications_none", ""];
export const SOURCE_LABEL = item => {
  const t = String(item.eventType || "");
  const p = t.split(".")[0];
  return {
    content: "Content Hub",
    studio: "Studio",
    board: "Boards",
    quote: "Quotes",
    flight: "Campaigns",
    wallet: "Campaigns",
    connection: "Connections"
  }[p] || "Plunk";
};

/** "Today 10:02", "Yesterday", "Mon", "Oct 14" */
export function whenLabel(iso) {
  const d = new Date(/Z|[+-]\d\d:?\d\d$/.test(String(iso)) ? iso : `${iso}Z`);
  if (isNaN(d)) return "";
  const now = new Date();
  const day = x => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diff = Math.round((day(now) - day(d)) / 86400000);
  if (diff <= 0) return d.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit"
  });
  if (diff === 1) return "Yesterday";
  if (diff < 7) return d.toLocaleDateString([], {
    weekday: "short"
  });
  return d.toLocaleDateString([], {
    month: "short",
    day: "numeric"
  });
}

/** Open what an item is about: an in-app path through the router, anything else in the browser. */
export function openItem(item, history) {
  const u = String(item.deeplinkUrl || "");
  if (!u) return;
  if (u.startsWith("/") && history) history.push(u);else if (/^https?:\/\//i.test(u)) window.open(u, "_blank", "noopener");
}